export default __webpack_public_path__ + "static/media/mint.feddc68e.png";